import React, { Component } from 'react';
import Radar from '../charts/radar';
import ContactForm from '../inputs/contactForm';
import ThankYou from './thankYou';
import Error from './error';

import { FiMail, FiPhone } from 'react-icons/fi'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

import { calculateWeightedScores, calculateSingleScores, recommendation } from '../../helpers/calculators';

import { filter } from '../../helpers/filter';

import './results.css';


class Results extends Component {

  calculateScores() {
    const { goals, industries, ageRanges } = this.props.appState

    const calculationData = {
      goals: {
        userSelect: goals,
        influencerSpecs: this.props.data.objectives,
      },
      industries: {
        userSelect: industries,
        influencerSpecs: this.props.data.industries,
      },
      ageRanges: {
        userSelect: ageRanges,
        influencerSpecs: this.props.data.ageRanges,
      }
    }

    const weightedScores = calculateWeightedScores(calculationData)
    const goalScores = calculateSingleScores(calculationData.goals)
    const industryScores = calculateSingleScores(calculationData.industries)
    const ageScores = calculateSingleScores(calculationData.ageRanges)
    const infReco = recommendation(calculationData)

    return {
      weightedScores,
      goalScores,
      industryScores,
      ageScores,
      recommendation: infReco
    }
  }

  briefingText(items) {
    return items.data.map((item, index, arr) =>
      arr.length === 1 ? item
      : arr.length-1 === index ? ` ${items.copy.and} ` + item
      : arr.length-2 === index ? item
      : item + ", "
    )
  }

  briefingTargetGroupText(items) {

    const { and, years, allRanges, singleRange, multipleRanges } = items.copy

    const gender = items.briefingGender.map((gender, index, arr) =>
      arr.length === 1 ? gender
      : arr.length-1 === index ? ` ${and} ` + gender
      : gender
    )

    const middlePart =
      items.age.length === this.props.appState.maxAgeRanges ? ` ${allRanges}`
      : items.age.length > 1 ? ` ${multipleRanges} `
      : ` ${singleRange} `

    const sortedAge = items.age.sort((a, b) => a.localeCompare(b, undefined, {numeric: true}))

    const age = sortedAge.map((age, index, arr) =>
      arr.length === this.props.appState.maxAgeRanges ? ''

      : arr.length === 1 ? age +  ` ${years}`
      : arr.length-1 === index ? ` ${and} ` + age + ` ${years}`
      : arr.length-2 === index ? age
      : age + ", "
    )

    return (gender.concat(middlePart).concat(age))
  }


  componentDidMount() {
    const scores = this.calculateScores()
    this.props.saveScoresToState(scores)
    this.props.triggerNext()
  }

  render() {

    const infReco = this.calculateScores().recommendation

    const {
      productName,
      weightedScores,
      goals,
      industries,
      ageRanges,
      gender,
      other,
      companyUrl,
      companyName,
      afterSavePage,
      email,
      phone,
      optin,
    } = this.props.appState

    const { inputs, contact, results, thankYou, error } = this.props.copy

    const {
      infTypes,
      hint,
      background,
    } = results

    const briefingGoals = goals.map(goal => inputs.goals[goal])
    const briefingIndustries = industries.map(industry => inputs.industries[industry])
    const briefingGender = gender.map(gender => background.basis.helpers[gender])
    const briefingAgeRanges = ageRanges.map(range => inputs.ageRanges[range])

    return(
      <div className="results-row">
        <div className="results-header-row">
          <div className="results-headline">
            <h1>{results.h1}</h1>

            {infReco.topTwo.length === 0 &&
              <h2>{results.h2.single}</h2>
            }

            {infReco.topTwo.length > 0 &&
              <h2>{results.h2.multiple}</h2>
            }

          </div>
          <div className="results-logo" />
        </div>


        <div className="chart-row">
            <Radar
              data={weightedScores}
            />

          <div className="reco-text-box">
            <div className="reco-top-one">
              <h2>{infTypes[infReco.topOne].title}</h2>
              <p>{infTypes[infReco.topOne].description}</p>
            </div>
            {infReco.topTwo &&
              <div className="reco-top-two">
                <h2>{infTypes[infReco.topTwo].title}</h2>
                <p>{infTypes[infReco.topTwo].description}</p>
              </div>
            }
          </div>
        </div>




        <div className="explanation-row" style={{marginBottom: afterSavePage === "" ? "610px" : "100px"}}>

          <p style={{marginBottom: '75px'}}>{hint}</p>


          <h2>{background.headline}</h2>
          <p>{background.description}</p>

          <h3>{background.basis.headline}</h3>


          <ul className="briefing-list">
            <li>
              <FontAwesomeIcon icon={faCheck} className="font-awesome-icon"/>
              {background.basis.product} {filter.clean(productName)}
            </li>

            <li>
              <FontAwesomeIcon icon={faCheck} className="font-awesome-icon"/>
              {background.basis.goals} {this.briefingText({data: briefingGoals, copy: background.basis.helpers})}
            </li>

            <li>
              <FontAwesomeIcon icon={faCheck} className="font-awesome-icon"/>
              {background.basis.industries} {this.briefingText({data: briefingIndustries, copy: background.basis.helpers})}
            </li>

            <li>
              <FontAwesomeIcon icon={faCheck} className="font-awesome-icon"/>
              {background.basis.target} {this.briefingTargetGroupText({age: briefingAgeRanges, briefingGender, copy: background.basis.helpers})}

            </li>

            {other.length > 0 &&
              <li>
                <FontAwesomeIcon icon={faCheck} className="font-awesome-icon"/>
                {background.basis.other} {filter.clean(other)}
              </li>
            }
          </ul>



          <div className="explanantion-row-goals">
            <h3>{background.goals.headline}</h3>

            <h4>{inputs.goals[goals[0]]}</h4>
            <p>{background.goals[goals[0]]}</p>

            {
              goals.length > 1 &&
                <div>
                  <h4>{inputs.goals[goals[1]]}</h4>
                  <p>{background.goals[goals[1]]}</p>
                </div>
            }

            <div className="explanation-fade-out-box">
              <div className="contact-details-row drop-shadow-extra-large">

                {afterSavePage === '' &&
                  <div>
                    <h1>{contact.h1}</h1>
                    <p>{contact.p}</p>
                    <ContactForm
                      companyName={companyName}
                      companyUrl={companyUrl}
                      email={email}
                      phone={phone}
                      optin={optin}
                      updateEmail={(value) => this.props.updateEmail(value)}
                      updatePhone={(value) => this.props.updatePhone(value)}
                      updateOptin={() => this.props.updateOptin()}
                      saveResultsToDatabase={() => this.props.saveResultsToDatabase()}
                      copy={contact.form}
                    />
                  <div className="contact-details-logo-row">
                    <div className="contact-details-logo"/>
                    <div>
                      <p><FiMail size="16" color="#fff" style={{paddingRight: '10px'}}/>{contact.mail}</p>
                      <p><FiPhone size="16" color="#fff" style={{paddingRight: '10px'}}/>{contact.phone}</p>
                    </div>
                  </div>

                </div>
                }

                {afterSavePage === "success"
                  && <ThankYou copy={thankYou}/>
                }

                {afterSavePage === "error"
                  && <Error copy={error} />
                }

              </div>

            </div>
          </div>
        </div>


      </div>
    )
  }
}

export default Results;
